(function($) {
  
    $(document).ready(function() {
        
    });
  
})(jQuery);

function initPopinLoginform(){
    var $ = jQuery;
    $('body').on('click', '.js-open-loginform', function(e){
        //if($('.m-header-menu-opener').is(":hidden")){
            e.preventDefault();
            pxOpenLoginForm();
        //}
    })
    if(window.location.hash) {
        console.log(window.location.hash);
        if(window.location.hash == '#loginform'){
            //window.setTimeout(function(){
                //$('.js-open-loginform').trigger('click');
                pxOpenLoginForm()
            //},150)
        }
    }
}

function pxOpenLoginForm(){
    var $ = jQuery;
    $('body').removeClass('is-popup-lockedpost-shown')
    $('body').addClass('is-loginform-shown')
    $('body').addClass('is-overlay-visible');
    $('body,html').animate({'scrollTop' : 0}, {duration: 300});
    window.setTimeout(function(){
        $('body').removeClass('has-open-menu');
        $('head meta[name="theme-color"]').attr('content','#202020');
    },100);
    $('.m-popin-loginform .close').click(function(){
        $('body').removeClass('is-loginform-shown')
        $('body').removeClass('is-overlay-visible');
        $('head meta[name="theme-color"]').attr('content','#fff');
    })
    $('.js-change-form').on('click',function(){
        $('.m-popin-loginform').toggleClass('is-form-forgotten')
    })
}